module.exports = {
      id: "socialshare-usage",
      viewBox: "0 0 23.63 25.957",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#socialshare",
      toString: function () {
        return this.url;
      }
    }